import { render, staticRenderFns } from "./KnFormProduct.vue?vue&type=template&id=30fbd64d&"
import script from "./KnFormProduct.vue?vue&type=script&lang=js&"
export * from "./KnFormProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports